import './bootstrap'
import { createApp } from 'vue'
import VueElementLoading from 'vue-element-loading'

import DepartureAreaListComponent from './components/Top/DepartureAreaList.vue'
import OneWeekBestPriceListComponent from './components/Top/OneWeekBestPriceList.vue'
import OneWeekBestPriceComponent from './components/Top/OneWeekBestPrice.vue'
import TransBestPriceListComponent from './components/Top/TransBestPriceList.vue'
import TransBestPriceComponent from './components/Top/TransBestPrice.vue'
import MonthListComponent from './components/Top/MonthList.vue'

const topApp = createApp({})
topApp.component('DepartureAreaListComponent', DepartureAreaListComponent)
topApp.component('OneWeekBestPriceListComponent', OneWeekBestPriceListComponent)
topApp.component('OneWeekBestPriceComponent', OneWeekBestPriceComponent)
topApp.component('TransBestPriceListComponent', TransBestPriceListComponent)
topApp.component('TransBestPriceComponent', TransBestPriceComponent)
topApp.component('MonthListComponent', MonthListComponent)
topApp.component('VueElementLoading', VueElementLoading)
topApp.mount('.top-app')

import SearchComponent from './components/Search/Search.vue'
import SearchDepartureAreaComponent from './components/Search/DepartureArea.vue'
import SearchDeparturePrefComponent from './components/Search/DeparturePref.vue'
import SearchDepartureComponent from './components/Search/Departure.vue'
import SearchDestinationAreaComponent from './components/Search/DestinationArea.vue'
import SearchDestinationPrefComponent from './components/Search/DestinationPref.vue'
import SearchDestinationComponent from './components/Search/Destination.vue'
import SearchDateComponent from './components/Search/Date.vue'
import SearchTransportationComponent from './components/Search/Transportation.vue'
import SearchTransportationCheckComponent from './components/Search/TransportationCheck.vue'
import SearchOptionComponent from './components/Search/Option.vue'
import SearchButtonComponent from './components/Search/SearchButton.vue'
import SearchDepartureSpComponent from './components/Search/DepartureSp.vue'
import SearchDestinationSpComponent from './components/Search/DestinationSp.vue'

const searchApp = createApp({})
searchApp.component('SearchComponent', SearchComponent)
searchApp.component('SearchDepartureAreaComponent', SearchDepartureAreaComponent)
searchApp.component('SearchDeparturePrefComponent', SearchDeparturePrefComponent)
searchApp.component('SearchDepartureComponent', SearchDepartureComponent)
searchApp.component('SearchDestinationAreaComponent', SearchDestinationAreaComponent)
searchApp.component('SearchDestinationPrefComponent', SearchDestinationPrefComponent)
searchApp.component('SearchDestinationComponent', SearchDestinationComponent)
searchApp.component('SearchDateComponent', SearchDateComponent)
searchApp.component('SearchTransportationComponent', SearchTransportationComponent)
searchApp.component('SearchTransportationCheckComponent', SearchTransportationCheckComponent)
searchApp.component('SearchOptionComponent', SearchOptionComponent)
searchApp.component('SearchButtonComponent', SearchButtonComponent)
searchApp.component('SearchDepartureSpComponent', SearchDepartureSpComponent)
searchApp.component('SearchDestinationSpComponent', SearchDestinationSpComponent)
searchApp.mount('#search-app')

import NavComponent from './components/Parts/nav.vue'
const navApp = createApp({})
navApp.component('NavComponent', NavComponent)
navApp.mount('#navApp')

import CountComponent from './components/Parts/count.vue'
const countApp = createApp({})
countApp.component('CountComponent', CountComponent)
countApp.mount('#countApp')
